import React from 'react';

import { LoginLoc } from '../loc/login';
import { loc } from '../lib/loc';
import { getPath } from '../utils/getPath';

export default function LoginAvantages() {
  return (
    <div className="advantages-cabinet">
      <div className="advantages-cabinet__item">
        <div className="advantages-cabinet__wrap-icon">
          <img className="advantages-cabinet__icon" src={getPath('public/img/clock-icon.svg')} alt="clock" />
        </div>
        <div className="advantages-cabinet__wrap-text">
          <div className="advantages-cabinet__title">{loc(LoginLoc.advantages.quickOrder.title)}</div>
          <div className="advantages-cabinet__text">{loc(LoginLoc.advantages.quickOrder.detail)}</div>
        </div>
      </div>
      <div className="advantages-cabinet__item">
        <div className="advantages-cabinet__wrap-icon">
          <img className="advantages-cabinet__icon" src={getPath('public/img/percent-icon.svg')} alt="percent" />
        </div>
        <div className="advantages-cabinet__wrap-text">
          <div className="advantages-cabinet__title">{loc(LoginLoc.advantages.personalBonus.title)}</div>
          <div className="advantages-cabinet__text">{loc(LoginLoc.advantages.personalBonus.detail)}</div>
        </div>
      </div>
      <div className="advantages-cabinet__item">
        <div className="advantages-cabinet__wrap-icon">
          <img className="advantages-cabinet__icon" src={getPath('public/img/reload-time-icon.svg')} alt="reload time" />
        </div>
        <div className="advantages-cabinet__wrap-text">
          <div className="advantages-cabinet__title">{loc(LoginLoc.advantages.orderHistory.title)}</div>
          <div className="advantages-cabinet__text">{loc(LoginLoc.advantages.personalBonus.detail)}</div>
        </div>
      </div>
    </div>
  );
}
